import { AuthenticationServiceTokens } from '../../di-tokens';
import { PlatformResolver } from '../interfaces';
import { InvalidPlatformError } from '../errors';

export interface PlatformJWTPayload {
    'eloomi-platform-id': string;
}

export abstract class PlatformServiceBase {
    public static inject = [AuthenticationServiceTokens.PlatformResolutionService] as const;

    constructor(private readonly platformResolver: PlatformResolver) {}

    protected async validatePlatform(payload: PlatformJWTPayload) {
        let isPlatformValid = false;
        if (this.platformResolver) {
            const { id } = await this.platformResolver.getPlatformData();
            isPlatformValid = id === Number(payload['eloomi-platform-id']);
        }

        if (!isPlatformValid) {
            throw new InvalidPlatformError();
        }
    }
}
